module.exports = __webpack_public_path__ + "static/img/shoutieyouli.1848ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/shoutieyouli.png
// module id = ZWvE
// module chunks = 70